import { Component, OnDestroy, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { concat, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-service-manager-filter',
  templateUrl: './service-manager-filter.component.html',
  styleUrls: ['./service-manager-filter.component.css']
})
export class ServiceManagerFilterComponent implements OnInit, OnDestroy {
  items$: Observable<any>;
  itemInput$ = new Subject<any>();

  @Input() itemMetadata: any;
  @Input() items: any[];
  @Input() isDropDown: boolean;
  @Output() selected: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    if (this.items && this.items.length > 0 && this.items.length < 50) {
      this.itemMetadata.selected = this.items[0];
    }
    else {
      this.itemMetadata.selected = null;
    }
    this.registerLookups();
  }

  ngOnDestroy() {
    this.itemInput$.unsubscribe();
  }

  registerLookups() {
    this.items$ = concat(
      this.itemInput$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        map(term => {
          return this.items.filter(item => {
            return Object.values(item).some(value =>
              value?.toString().toLowerCase().includes(term?.toLowerCase())
            );
          }).slice(0, 8);
        })
      )
    );
  }

  onTypeAheadSelect(): void {
    this.selected.emit({
      $item: this.itemMetadata.idProperty == "HQCo" && this.itemMetadata.selected?.HQCo == -1 ?  null : this.itemMetadata.selected,
      $itemMetadata: this.itemMetadata
    });
    if (this.itemMetadata.limit !== 1) {
      setTimeout(() => {
        this.clearFilter();
      }, 100);
    }
  }

  clearFilter() {
    if (this.isDropDown) {
      this.itemMetadata.selected = this.items[0];
    } else {
      this.itemMetadata.selected = null;
    }
  }

}